import axios from 'axios';
import { API_HOST } from '../helpers/constants';
import { headers } from '../utils';

const baseUrl = `${API_HOST}/faqs`;

export const createFaq = (payload) => {
  return axios.post(`${baseUrl}`, payload, { headers });
};

export const deleteFaq = (id) => {
  return axios.delete(`${baseUrl}/${id}`, { headers });
};

export const updateFaq = (id, payload) => {
  return axios.put(`${baseUrl}/${id}`, payload, { headers });
};
